// extracted by mini-css-extract-plugin
export default {"PrintWrapper":"PrintOrderInfo_PrintWrapper__ZNgtx"};